<div class="spectrum">
  <div class="limits omit-from-screenshot">
    <span class="limit-group">
      <span class="limit-label">Scale</span>
      <nz-radio-group
        nzSize="small"
        [ngModel]="limits().scale"
        (ngModelChange)="setScale($event)"
      >
        @for (s of scales; track s.value) {
          <label nz-radio-button [nzValue]="s.value">{{ s.label }}</label>
        }
      </nz-radio-group>
    </span>

    <span class="limit-group" nz-tooltip nzTooltipTitle="Frequency axis (Hz). Empty = automatic.">
      <span class="limit-label">Hz</span>
      <nz-input-number
        nzSize="small"
        class="limit-input"
        nzPlaceHolder="0"
        [nzMin]="0"
        [ngModel]="limits().fMin"
        (ngModelChange)="setLimit('fMin', $event)"
      ></nz-input-number>
      <span class="dash">–</span>
      <nz-input-number
        nzSize="small"
        class="limit-input"
        [nzPlaceHolder]="nyquist() ? '' + nyquist() : 'max'"
        [nzMin]="0"
        [ngModel]="limits().fMax"
        (ngModelChange)="setLimit('fMax', $event)"
      ></nz-input-number>
    </span>

    <span class="limit-group" nz-tooltip [nzTooltipTitle]="'Amplitude axis (' + ampUnit() + '). Empty = automatic.'">
      <span class="limit-label">{{ ampUnit() }}</span>
      <nz-input-number
        nzSize="small"
        class="limit-input"
        nzPlaceHolder="auto"
        [ngModel]="limits().aMin"
        (ngModelChange)="setLimit('aMin', $event)"
      ></nz-input-number>
      <span class="dash">–</span>
      <nz-input-number
        nzSize="small"
        class="limit-input"
        nzPlaceHolder="auto"
        [ngModel]="limits().aMax"
        (ngModelChange)="setLimit('aMax', $event)"
      ></nz-input-number>
    </span>

    <button
      nz-button
      nzSize="small"
      nz-tooltip
      nzTooltipTitle="Use the current (scroll-zoomed) view as fixed limits"
      [disabled]="!options()"
      (click)="lockView()"
    >
      <span nz-icon nzType="lock"></span>
    </button>
    @if (hasLimits()) {
      <button nz-button nzType="link" nzSize="small" (click)="resetLimits()">
        auto
      </button>
    }
  </div>

  @if (options(); as opts) {
    <div
      echarts
      class="chart"
      [options]="opts"
      (chartInit)="onChartInit($event)"
    ></div>
  } @else {
    <div class="placeholder">
      @if (loading()) {
        <nz-spin></nz-spin>
      } @else {
        Spectrum of the displayed gather appears here.
      }
    </div>
  }
</div>
